import React from 'react';

import PageContext from '../contexts/PageContext';

import Orders from '../views/Orders';
import Profile from '../views/Profile';
import Calendar from '../views/Calendar';
import Inbox from '../views/Inbox';
import Trash from '../views/Trash';
import Loading from '../views/Loading';

export const pagesMap = {
  Orders: <Orders />,
  Profile: <Profile />,
  Calendar: <Calendar />,
  Inbox: <Inbox />,
  Trash: <Trash />,
  Loading: <Loading />
};

export default function PageComponent() {  
  const pageContext = React.useContext(PageContext);
  const currentPage = pageContext.currentPage;

  return (
    <React.Fragment>
      { pagesMap[currentPage] || pagesMap.Orders }
    </React.Fragment>
  );
}
